import { CSSProperties } from 'react';

export const horizontalCenter: CSSProperties = {
  marginLeft: '50%',
  transform: 'translateX(-50%)',
};
